export default {
  goal: {
    canUpdate: 'Accéder au parcours de conseil réallocation',
    disabled: 'Non disponible avec ce choix de profil utilisateur',
    mustUpdate: "Réaliser votre qualification en amont de l'assistant",
  },
  profileDefault: 'Sécuritaire',
  label: 'Votre qualification',
}
